import { jsxs as i, jsx as r } from "react/jsx-runtime";
import { ListItemContainer as s, ListItemLeftContent as c, ListItemIcon as l, SelectedIcon as f } from "./style.js";
import { Check as I } from "@pelando/fontawesome/icons";
import { useTranslation as p } from "../../hooks/useTranslation/index.js";
function x({
  icon: t,
  text: o,
  onClick: n,
  selected: e,
  ...m
}) {
  const { t: a } = p("common");
  return /* @__PURE__ */ i(
    s,
    {
      onClick: n,
      ...m,
      "aria-selected": e,
      children: [
        /* @__PURE__ */ i(c, { children: [
          t && /* @__PURE__ */ r(l, { children: t }),
          o
        ] }),
        e && /* @__PURE__ */ r(f, { icon: I, "aria-label": a("list-item-aria-label") })
      ]
    }
  );
}
export {
  x as ListItem,
  l as ListItemIcon
};
